import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useState, createContext } from "react";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import "bootstrap/dist/css/bootstrap.min.css";
import "./sass/Main.scss";
import 'rc-slider/assets/index.css';
import Playground from "./pages/Playground";
import Home from "./pages/Home";
import Help from "./pages/Help";
import Explore from "./pages/Explore";
import PairPage from "./pages/Pair";
import { ROUTES } from "./constant/routes";
import { HEADER_INPUT,DESCRIPTION_INPUT } from './constant'
import { useVisitorId } from "./hooks/useVisitorId"

export  const UserContext = createContext();
function App() {
  useVisitorId();
  const [headerInput, setheaderInput] = useState(HEADER_INPUT);
  const [descriptionInput, setdescriptionInput] = useState(DESCRIPTION_INPUT);
  const [smallFontSizeUpdated, setSmallFontSizeUpdated] = useState(false);
  const [largeFontSizeUpdated, setLargeFontSizeUpdated] = useState(false);
  const [headerInputUpdated, setheaderInputUpdated] = useState(false);
  const [descriptionInputUpdated, setdescriptionInputUpdated] = useState(false);
  const [states, setStates] = useState([{}]); // Used to store history of all states
  const [index, setIndex] = useState(0); // Index of current state within `states`

  return (
    <div >
    <UserContext.Provider 
      value={
        {
          headerInput,
          setheaderInput,
          descriptionInput,
          setdescriptionInput,
          smallFontSizeUpdated,
          setSmallFontSizeUpdated,
          largeFontSizeUpdated,
          setLargeFontSizeUpdated,
          headerInputUpdated,
          setheaderInputUpdated,
          descriptionInputUpdated,
          setdescriptionInputUpdated,
          states,
          setStates,
          index,
          setIndex
        }
      }
    >
      <Router>
        <Routes>
          <Route path={ROUTES.HOME} element={<Home />} />
          <Route path={ROUTES.PLAYGROUND} element={<Playground help={false}/>} />
          <Route path={ROUTES.EXPLORE} element={<Explore />} />
          <Route path={ROUTES.PAIR} element={<PairPage />} />
          <Route path={ROUTES.HELP} element={<Playground help={true}/>} />
        </Routes>
      </Router>
    </UserContext.Provider>
    </div>
  );
}

export default App;
